export default [
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("@/views/login.vue")
  }
];
